var replaceClass = function(element, currClass, newClass) {
    if (!element) return;
    if (currClass) {
        element.classList.remove(currClass);
    }
    if (newClass) {
        element.classList.add(newClass);
    }
};
/**
 * Updates a CSS class both at the main body element of the page and, when available,
 * the body of an extension's iframe.
 * @param currClass: an optional class to remove from the body.
 * @param newClass: new class to add.
 */ export var updateBodyClass = function(currClass, newClass) {
    var _document_getElementById, _document_getElementById_contentWindow, _document_getElementById_contentWindow_document;
    var body = document.querySelector("body");
    // FIXME: how is this supposed to be tested?
    var iframeBody = (_document_getElementById = document.getElementById("ext-iframe")) === null || _document_getElementById === void 0 ? void 0 : (_document_getElementById_contentWindow = _document_getElementById.contentWindow) === null || _document_getElementById_contentWindow === void 0 ? void 0 : (_document_getElementById_contentWindow_document = _document_getElementById_contentWindow.document) === null || _document_getElementById_contentWindow_document === void 0 ? void 0 : _document_getElementById_contentWindow_document.querySelector("body");
    replaceClass(body, currClass, newClass);
    replaceClass(iframeBody, currClass, newClass);
};
